export default __webpack_public_path__ + "static/media/aleth.3dd80ea7.svg";